import type { TenantModuleGroup } from '../../constants/tenantModuleGroups';

/** Photographer cabinet. Blog and photographer news stay in platform admin, not here. */
export const tenantModuleGroups: TenantModuleGroup[] = [
  {
    id: 'overview',
    labelKey: 'nav.group.overview',
    modules: ['overview', 'notes', 'album_reviews', 'album_published_reviews', 'album_requests'],
  },
  {
    id: 'catalog',
    labelKey: 'nav.group.catalog',
    modules: ['galleries', 'album_books', 'visiting_card'],
  },
  {
    id: 'system',
    labelKey: 'nav.group.system',
    modules: ['settings'],
  },
];
